export default __webpack_public_path__ + "static/media/ui_common_cover.a37afd13.svg";